module.exports = __webpack_public_path__ + "img/img_forest@2x.e6d027bb.png";